// extracted by mini-css-extract-plugin
module.exports = {"postPage":"BlogPostPage_postPage__vNn6q"};